/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _vdkwebNavigation = require("@accedo/vdkweb-navigation");
var _FocusButton = _interopRequireDefault(require("./FocusButton"));
var _errorTile = _interopRequireDefault(require("./errorTile.scss"));
var _coordinateUtils = require("../utils/coordinateUtils");
var _focusHelper = require("../utils/focusHelper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * A tile for displaying error information when
 * a coordinate load has failed.
 * Displays the error message given to it and a button
 * to trigger retry attempts for re-launching the failed request.
 *
 * Supports key navigation and focusing with @accedo/vdkweb-navigation.
 *
 * @class ErrorFocusTile
 * @extends {React.PureComponent}
 */
var ErrorFocusTile = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ErrorFocusTile, _React$PureComponent);
  var _super = _createSuper(ErrorFocusTile);
  function ErrorFocusTile() {
    var _this;
    _classCallCheck(this, ErrorFocusTile);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getId", function () {
      var _this$props$coordinat = _this.props.coordinate,
        x = _this$props$coordinat.x,
        y = _this$props$coordinat.y;
      return "error_".concat(x, "_").concat(y);
    });
    return _this;
  }
  _createClass(ErrorFocusTile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isSelected = this.props.isSelected;
      if (isSelected) {
        _vdkwebNavigation.focusManager.changeFocus(this.getId());
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
        coordinate = _this$props.coordinate,
        onMoveTo = _this$props.onMoveTo;
      if (!(0, _focusHelper.isNavigatingToTile)(this.props)) {
        return;
      }
      _vdkwebNavigation.focusManager.changeFocus(this.getId());
      onMoveTo && onMoveTo(coordinate);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        width = _this$props2.width,
        height = _this$props2.height,
        error = _this$props2.error,
        onMoveTo = _this$props2.onMoveTo,
        onReload = _this$props2.onReload,
        style = _this$props2.style,
        theme = _this$props2.theme,
        buttonText = _this$props2.buttonText,
        coordinate = _this$props2.coordinate;
      var _style = _objectSpread({
        width: width,
        height: height
      }, style);
      var moveTo = function moveTo(toCoordinate) {
        onMoveTo && onMoveTo(toCoordinate, {
          fromCoordinate: coordinate,
          toCoordinate: toCoordinate
        });
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.errorTile,
        style: _style
      }, error ? /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.text
      }, error) : '', /*#__PURE__*/_react["default"].createElement(_FocusButton["default"], {
        nav: {
          id: this.getId(),
          internal: {
            nextleft: function nextleft() {
              return moveTo((0, _coordinateUtils.getNextCoordinateLeft)(coordinate)) || true;
            },
            nextright: function nextright() {
              return moveTo((0, _coordinateUtils.getNextCoordinateRight)(coordinate)) || true;
            },
            nextup: function nextup() {
              return moveTo((0, _coordinateUtils.getNextCoordinateUp)(coordinate)) || true;
            },
            nextdown: function nextdown() {
              return moveTo((0, _coordinateUtils.getNextCoordinateDown)(coordinate)) || true;
            }
          }
        },
        onClick: onReload
      }, buttonText));
    }
  }]);
  return ErrorFocusTile;
}(_react["default"].PureComponent);
ErrorFocusTile.propTypes = {
  /** Text rendered in the button */
  buttonText: _propTypes["default"].string,
  /** The coordinate for this tile in the data grid. */
  coordinate: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }).isRequired,
  /** Error text to be displayed */
  error: _propTypes["default"].string,
  /** Height of the tile */
  height: _propTypes["default"].number,
  /** Whether it should autofocus */
  isSelected: _propTypes["default"].bool,
  /**
   * Handler for datagrid movement:
   * ```onMoveTo(coordinate, navigationData)```
   *
   * Will notify which coordinate to move to
   * and any relevant data the target coordinate
   * needs to handle focus properly for the transition.
   */
  onMoveTo: _propTypes["default"].func,
  /** Handler for triggering a reload of data. */
  onReload: _propTypes["default"].func,
  /** Style object which will be applied to the outer container div */
  style: _propTypes["default"].object,
  /** Classname API for theming */
  theme: _propTypes["default"].shape({
    errorTile: _propTypes["default"].string,
    text: _propTypes["default"].string
  }),
  /** Width of the tile */
  width: _propTypes["default"].number
};
ErrorFocusTile.defaultProps = {
  buttonText: 'Retry',
  theme: _errorTile["default"]
};
var _default = ErrorFocusTile;
exports["default"] = _default;